<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
require('video.js/dist/video-js.css')
    require('vue-video-player/src/custom-theme.css')
export default {
  name: 'app'
}
</script>

<style lang="less">
@font-face {font-family: 'handfont';
  src: url('fonts/handfont.eot'); /* IE9*/
  src: url('fonts/handfont.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('fonts/handfont.woff') format('woff'), /* chrome、firefox */
  url('fonts/handfont.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
  url('fonts/handfont.svg#handfont') format('svg'); /* iOS 4.1- */
}
@font-face {
    font-family: 'Gotham';
    src:url('fonts/Gotham-Bold_0.ttf'),url('fonts/Gotham-Bold_0.otf'),
}
button:focus{
    border-width: 0 !important;
    outline:none !important;
}
*{
     -webkit-tap-highlight-color: transparent;
}
.vjs-custom-skin > .video-js .vjs-play-progress, .vjs-custom-skin > .video-js .vjs-volume-level {
    background-color: #0057f7 !important;
}
.vjs-custom-skin > .video-js .vjs-big-play-button{
    background-color: transparent !important;
}
.video-js .vjs-big-play-button{
    border-width: 0 !important;
}
.video-js:hover .vjs-big-play-button,.vjs-custom-skin > .video-js .vjs-big-play-button:focus,.vjs-custom-skin > .video-js .vjs-big-play-button:active {
    background-color: transparent !important;
}
.video-js{
    background-color: transparent !important;
}
.video-js{
    height: ~"calc(90vw / (1280 / 720))" !important;
}
.vjs-poster{
    background-color: transparent;
}
*{font-family:"handfont";}
.fold-enter-active, .fold-leave-active {
    transition: all .5s;
}
.fold-enter, .fold-leave-active {
    transform: translate3d(0, 0, 0);
}
html, body, div, span, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
abbr, address, cite, code,
del, dfn, em, img, ins, kbd, q, samp,
small, strong, sub, sup, var,
b, i,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section, summary,
time, mark, audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
}

body {
    line-height:1;
}

:focus {
    outline: 1;
}

article,aside,canvas,details,figcaption,figure,
footer,header,hgroup,menu,nav,section,summary { 
    display:block;
}

nav ul {
    list-style:none;
}

blockquote, q {
    quotes:none;
}

blockquote:before, blockquote:after,
q:before, q:after {
    content:'';
    content:none;
}

a {
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
}

ins {
    background-color:#ff9;
    color:#000;
    text-decoration:none;
}

mark {
    background-color:#ff9;
    color:#000; 
    font-style:italic;
    font-weight:bold;
}

del {
    text-decoration: line-through;
}

abbr[title], dfn[title] {
    border-bottom:1px dotted #000;
    cursor:help;
}

table {
    border-collapse:collapse;
    border-spacing:0;
}

hr {
    display:block;
    height:1px;
    border:0;   
    border-top:1px solid #cccccc;
    margin:1em 0;
    padding:0;
}

input, select {
    vertical-align:middle;
}
body,html{
    max-width: 750px;
    margin: auto;
    overflow: hidden;
    position: relative;
    &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 4px;
    } 
    &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: #b3b3b3;
        -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
    }
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    

}
.modal {
    width: 270px;
    position: absolute;
    z-index: 13500;
    left: 50%;
    margin-left: -135px;
    margin-top: -50px;
    top: 50%;
    text-align: center;
    border-radius: 13px;
    overflow: hidden;
    opacity: 0;
    -webkit-transform: translate3d(0,0,0) scale(1.185);
    transform: translate3d(0,0,0) scale(1.185);
    -webkit-transition-property: -webkit-transform,opacity;
    -moz-transition-property: -moz-transform,opacity;
    -ms-transition-property: -ms-transform,opacity;
    -o-transition-property: -o-transform,opacity;
    transition-property: transform,opacity;
    color: #000;
    opacity: 1;
    -webkit-transition-duration: .4s;
    transition-duration: .4s;
    -webkit-transform: translate3d(0,0,0) scale(1);
    transform: translate3d(0,0,0) scale(1);
}
.modal-inner {
    padding: 15px;
    border-radius: 13px 13px 0 0;
    position: relative;
    background: rgba(255,255,255,.95);
}
.modal-title {
    font-weight: 500;
    font-size: 18px;
    text-align: center;
}
.modal-title+.modal-text {
    margin-top: 20px;
}
.modal-inner:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    right: auto;
    top: auto;
    height: 1px;
    width: 100%;
    background-color: rgba(0,0,0,.2);
    display: block;
    z-index: 15;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
}
.modal-buttons {
    height: 44px;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}
.modal-button:first-child:last-child {
    border-radius: 0 0 13px 13px;
}
.modal-button {
    width: 100%;
    padding: 0 5px;
    height: 44px;
    font-size: 17px;
    line-height: 44px;
    text-align: center;
    color: #007aff;
    display: block;
    position: relative;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    box-sizing: border-box;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    background: rgba(255,255,255,.95);
}
</style>


// WEBPACK FOOTER //
// src/App.vue